<template>
	<div>
		<!-- messages -->
		<v-toolbar
			v-if="userProfile.role == 'person'"
			flat
			color="secondary"
			class="rounded mb-3 title white--text"
		>
			<avatar
				size="40"
				class="ma-2"
				:name="adminProfile.name"
				:last-name="adminProfile.lastName"
				:url="adminProfile.img"
				filled
				hide-details
			/>
			{{ adminProfile.name }} {{ adminProfile.lastName ? adminProfile.lastName : '' }}
		</v-toolbar>
		<div v-if="conversations.length" class="scroll">
			<v-row
				v-for="(item, i) in conversations"
				:key="i"
				:justify="alert(item) ? 'end' : 'start'"
			>
				<v-col cols="8" class="pt-0 px-4">
					<div
						class="text--primary caption text-capitalize ma-2"
						:class="alert(item) ? 'text-right' : 'text-left'"
					>
						{{ item.sender }}
					</div>
					<v-alert
						text
						class=" text-left mr-0"
						style="padding-right: 4px !important; "
						:class="alert(item) ? 'rounded-l-xl' : 'rounded-r-xl'"
						color="secondary"
					>
						<div class="message m-2 p-2">{{ item.content }}</div>
					</v-alert>
					<div
						class="caption text--secondary ma-2"
						:class="alert(item) ? 'text-right' : 'text-left'"
					>
						{{ formatTime(item.createdAt) }}
					</div>
				</v-col>
			</v-row>
		</div>
		<div v-else style="height: 370px">
			<v-overlay :value="overlay" absolute :opacity="0.8" z-index="2">
				<v-icon x-large>mdi-email-alert-outline</v-icon>
				<div>¡No tienes mensajes!</div>
				<v-btn small class="ma-2" color="primary" @click="overlay = false">
					Inicia una conversacion
				</v-btn>
			</v-overlay>
		</div>
		<v-row justify="center">
			<v-col cols="12" class="pa-4">
				<form @submit.prevent="setMessage">
					<v-text-field
						v-model="text"
						:disabled="sending"
						hide-details
						color="primary"
						outlined
						dense
						:loading="sending"
						filled
						autocomplete="off"
						label="Escriba un comentario..."
						type="text"
					>
						<template v-slot:append>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn
										:loading="sending"
										x-small
										text
										fab
										color="success"
										type="submit"
									>
										<v-icon v-on="on">mdi-send</v-icon>
									</v-btn>
								</template>
								Enviar mensaje
							</v-tooltip>
						</template>
					</v-text-field>
				</form>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
	components: {
		Avatar: () => import('@/components/ui/Avatar'),
	},
	props: {
		id: {
			type: String,
			default: '',
		},
		sender: {
			type: String,
			required: true,
		},
		receiver: {
			type: String,
			required: true,
		},
		adminProfile: { type: Object, default: null },
		conversations: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			overlay: true,
			text: '',
			loading: false,
			sending: false,
			notified: false,
		};
	},
	mounted() {
		this.scrollToElement();
	},
	methods: {
		async setMessage() {
			this.sending = true;
			const data = {
				id: this.id,
				payload: {
					sender: this.sender,
					senderId: this.userProfile._id,
					receiver: this.receiver,
					content: this.text,
				},
			};
			if (this.text) {
				await this.conversation(data);
				this.scrollToElement();
			}
			this.text = '';
			this.sending = false;
		},
		scrollToElement() {
			const el = this.$el.getElementsByClassName('scroll')[0];
			if (el) {
				el.scrollTop = el.scrollHeight;
			}
		},
		alert(item) {
			return item.sender.toLowerCase() === this.sender.toLowerCase();
		},
		formatTime(time) {
			return moment(time).fromNow();
		},
		...mapActions({
			conversation: 'Person/conversation',
		}),
	},
	watch: {
		conversations() {
			this.scrollToElement();
		},
	},
};
</script>

<style lang="scss" scoped>
.message {
	font-size: 10pt;
	max-width: 200px;
	overflow-wrap: break-word;
}
.scroll {
	height: 340px;
	overflow-y: auto;
	overflow-x: hidden;
}
</style>
